import { useState } from "react";
import { Grid, GridColumn } from "semantic-ui-react";

import { Dropdown, ResetFiltersButton, usePermanentRealtimeDealers, useSelectedDealer } from "components";
import { DealerLicenseNavbar, DealerLicenseTabs, InvoicingDisabledLocationsMessage } from "modules/DealerLicenseOverview/components";
import "modules/DealerLicenseOverview/DealerLicenseOverview.scss";
import { handleResetFilters, setDealerLicensesDashboardFilters, useDealerLicensesDashboardFilters, useDealerLicensesQuery } from "modules/DealerLicenseOverview/hooks";
import { InvoiceModal } from "modules/LocationLicenseOverview/components";
import "modules/LocationLicenseOverview/LocationLicenseOverview.scss";

import type { DropdownItemProps } from "components";
import type { HistoricalInvoice } from "modules/LocationLicenseOverview/queryKeys";

export const DealerLicenseOverview = () => {
  const [invoicePDF, setInvoicePDF] = useState<Blob | null>(null);
  const [selectedInvoice, setSelectedInvoice] = useState<HistoricalInvoice | null>(null);
  const { selectedDealer } = useSelectedDealer();

  const { data: licenses, refetch: refetchDealerLicenses, isFetching: isLoadingDealerLicenses } = useDealerLicensesQuery();
  const { dealers } = usePermanentRealtimeDealers();
  const { dealer } = useDealerLicensesDashboardFilters();

  const options: DropdownItemProps[] = dealers.map(({ id, name }) => ({ key: id, value: id, text: name })).sort((a, b) => a.text.localeCompare(b.text));

  const handleCloseInvoiceModal = () => {
    setInvoicePDF(null);
    setSelectedInvoice(null);
  };

  return (
    <>
      <div className="LocationLicenseOverview DealerLicenseOverview mt-20">
        <InvoicingDisabledLocationsMessage />
        <div className="filters">
          <Grid className="grid">
            <GridColumn width={5} className="no-left-gutter">
              <Dropdown
                fluid
                search
                selection
                value={dealer?.id}
                options={options}
                onChange={dealerId => setDealerLicensesDashboardFilters({ dealer: dealers.find(({ id }) => id === dealerId) || null })}
              />
            </GridColumn>

            <GridColumn floated="right">
              <div className="reset-button-container">
                <ResetFiltersButton handleReset={() => handleResetFilters(selectedDealer)} />
              </div>
            </GridColumn>
          </Grid>
        </div>
        <DealerLicenseNavbar licenses={licenses} />
        <DealerLicenseTabs
          setInvoicePDF={setInvoicePDF}
          setSelectedInvoice={setSelectedInvoice}
          refetchDealerLicenses={refetchDealerLicenses}
          licenses={licenses}
          isLoadingDealerLicenses={isLoadingDealerLicenses}
        />
      </div>

      <InvoiceModal isOpen={!!(selectedInvoice && invoicePDF)} onClose={handleCloseInvoiceModal} invoice={selectedInvoice as HistoricalInvoice} invoicePDF={invoicePDF} />
    </>
  );
};
